import { Component, Inject, Input, OnInit } from '@angular/core';
import {
    AUTH_SERVICE_IMPL,
    IAuthenticationService,
    ISelectOption,
    ModalService,
    OrderItem,
    OrderItemState,
    UserRole,
} from 'shared';
import { CollectingStatesService } from 'dm-src/app/modules/collecting/collecting-states.service';
import { OrderRemovedItemReasons } from 'projects/shared/src/lib/types/order-removed-item-reasons';
import { CollectingItemsService } from '../../../collecting-items.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { ProductIdentificationSource } from 'dm-src/types/product-identification-source';
import {
    IProductProviderService,
    PRODUCTPROVIDER_SERVICE_IMPL,
} from 'dm-src/services/productprovider/iproductprovider-service';
import { Order } from '../../../../../../models/order';
import { ProductLocationMap } from 'dm-src/dtos/product-location-map';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-order-item-modal-details',
    templateUrl: './order-item-modal-details.component.html',
    styleUrls: ['./order-item-modal-details.component.scss'],
})
export class OrderItemModalDetailsComponent implements OnInit {
    @Input() orderItem: OrderItem;
    @Input() orderRemovedItemReasons: OrderRemovedItemReasons[];
    public originalOrderedOrderItems: OrderItem[] = [];
    public previousOrderItem: OrderItem;
    public nextOrderItem: OrderItem;

    public orderItemState = OrderItemState;
    public onlineConsultation = false;
    public canEditProductMap = false;

    public shelfDisplayNameKeyEditInProgress = false;
    public shelfPositionDisplayNameKeyEditInProgress = false;

    public productLocationMaps: ProductLocationMap[];
    public shelfPositionDisplayNameKeys: string[];

    public maps: ISelectOption[];
    public selectedMap: ISelectOption;
    public selectedMapImageURL: string;

    public shelves: ISelectOption[];
    public selectedShelf: ISelectOption;

    constructor(
        private _ngbModalService: NgbModal,
        private _modalService: ModalService,
        private _translate: TranslateService,
        public states: CollectingStatesService,
        public collectingItemService: CollectingItemsService,
        @Inject(AUTH_SERVICE_IMPL)
        private _authService: IAuthenticationService,
        @Inject(PRODUCTPROVIDER_SERVICE_IMPL)
        private _productProviderService: IProductProviderService
    ) {
        this.maps = [];
        this.shelves = [];
    }

    ngOnInit() {
        const currentUser = this._authService.currentUser;
        this.canEditProductMap = currentUser.hasRoles([
            UserRole.Administrator,
            UserRole.ProductMapEditor,
        ]);

        if (this.states.multiCollectingStates?.length > 1) {
            let multiCollectingState = this.states.multiCollectingStates.find(
                (x) => x.orderID == this.orderItem.orderID
            );
            this.onlineConsultation = multiCollectingState.onlineConsultation;
        } else {
            this.onlineConsultation = this.states.onlineConsultation;
        }
    }

    /******************************PRODUCTMAP POSITION******************************* */
    editShelfDisplayNameKey() {
        this.closeShelfPositionDisplayNameKey(); //we close the other
        this.shelfDisplayNameKeyEditInProgress = true;
        this._productProviderService
            .getShelfDisplayNameKeys(this.orderItem.orderID)
            .subscribe((productLocationMaps) => {
                this.productLocationMaps = productLocationMaps.body;
                this.maps = this.productLocationMaps
                    .sort((a, b) => a.sequenceOrder - b.sequenceOrder)
                    .map((p) => ({
                        id: p.shelfDisplayNameKey,
                        label: this._translate.instant(p.shelfDisplayNameKey),
                    }));

                this.selectedMap = this.maps.find(
                    (p) => p.id === this.orderItem.shelfDisplayNameKey
                );

                this.selectedMapImageURL = this.productLocationMaps.find(
                    (p) => p.shelfDisplayNameKey === this.selectedMap.id
                ).imageURL;
            });
    }

    setNewMap() {
        this.selectedMapImageURL = this.productLocationMaps.find(
            (p) => p.shelfDisplayNameKey === this.selectedMap.id
        ).imageURL;
    }

    saveShelfDisplayNameKey() {
        if (confirm(this._translate.instant('common.are-you-sure'))) {
            const productlocationmapid = this.productLocationMaps.find(
                (p) => p.shelfDisplayNameKey === this.selectedMap.id
            ).productLocationMapId;

            this._productProviderService
                .setProductLocationMap(
                    this.orderItem.productProviderID,
                    productlocationmapid,
                    this.orderItem.orderID
                )
                .subscribe((result) => {
                    this.orderItem.shelfDisplayNameKey = result.body.shelfDisplayNameKey;
                    this.closeShelfDisplayNameKey();
                });
        } else {
            return;
        }
    }

    closeShelfDisplayNameKey() {
        this.shelfDisplayNameKeyEditInProgress = false;
    }

    /************************SHELF POSITION*************************/
    editShelfPositionDisplayNameKey() {
        this.closeShelfDisplayNameKey(); //we close the other
        this.shelfPositionDisplayNameKeyEditInProgress = true;
        this._productProviderService
            .getShelfPositionDisplayNameKeys(
                this.orderItem.productProviderID,
                this.orderItem.orderID
            )
            .subscribe((shelfPositionDisplayNameKeys) => {
                this.shelfPositionDisplayNameKeys = shelfPositionDisplayNameKeys.body;

                this.shelves = this.shelfPositionDisplayNameKeys.map((p) => ({
                    id: p,
                    label: this._translate.instant(p),
                }));

                this.selectedShelf = this.shelves.find(
                    (p) => p.id === this.orderItem.shelfPositionDisplayNameKey
                );
            });
    }

    setNewShelfPosition() {}

    saveShelfPositionDisplayNameKey() {
        if (confirm(this._translate.instant('common.are-you-sure'))) {
            const shelfpositiondisplaynamekey = this.shelfPositionDisplayNameKeys.find(
                (p) => p === this.selectedShelf.id
            );

            this._productProviderService
                .setShelfPositionDisplayNameKey(
                    this.orderItem.productProviderID,
                    shelfpositiondisplaynamekey,
                    this.orderItem.orderID
                )
                .subscribe((result) => {
                    this.orderItem.shelfPositionDisplayNameKey =
                        shelfpositiondisplaynamekey;
                    this.closeShelfPositionDisplayNameKey();
                });
        } else {
            return;
        }
    }

    closeShelfPositionDisplayNameKey() {
        this.shelfPositionDisplayNameKeyEditInProgress = false;
    }

    /************************************************************* */

    public showCreateItemModal(): void {
        if (!this.states.isPaymentReserved) {
            this.states.setCreateItemModalVisible(true);
        }
    }

    public showProductIdentifyModal(): void {
        this.collectingItemService
            .checkIfOrderModificationIsBlocked(this.states.orderID)
            .subscribe((underInspection) => {
                if (!underInspection) {
                    this.states.productIdentificationSource =
                        ProductIdentificationSource.ToPick;
                    this.states.replaceableOrderItem = null;
                    this._modalService.setModalVisibility(true, 'product-identify-modal');
                }
            });
    }

    goToPreviousOrderItem() {
        this._ngbModalService.dismissAll();
        this.handleOrderItemPagination(false);
    }

    goToNextOrderItem() {
        this._ngbModalService.dismissAll();
        this.handleOrderItemPagination(true);
    }

    handleOrderItemPagination(isNext: boolean) {
        this.collectingItemService.originalOrderedOrderItems.subscribe(
            (originalOrderedOrderItems) => {
                let currentOrderItemIndex = 0;
                this.originalOrderedOrderItems = originalOrderedOrderItems;
                currentOrderItemIndex = this.originalOrderedOrderItems.findIndex(
                    (x) => x.orderItemID === this.orderItem.orderItemID
                );

                if (isNext) {
                    if (
                        currentOrderItemIndex !==
                        this.originalOrderedOrderItems.length - 1
                    ) {
                        this.nextOrderItem =
                            this.originalOrderedOrderItems[currentOrderItemIndex + 1]; // next item
                    } else {
                        this.nextOrderItem = this.originalOrderedOrderItems[0]; // first item
                    }
                    this.collectingItemService.showOrderItemDetails(this.nextOrderItem);
                } else {
                    if (currentOrderItemIndex > 0) {
                        this.previousOrderItem =
                            this.originalOrderedOrderItems[currentOrderItemIndex - 1]; // previous item
                    } else {
                        this.previousOrderItem =
                            this.originalOrderedOrderItems[
                                this.originalOrderedOrderItems.length - 1
                            ]; // last item
                    }
                    this.collectingItemService.showOrderItemDetails(
                        this.previousOrderItem
                    );
                }
            }
        );
    }
}
